import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";

const initialState = {
    isLoading: false,
    isRefresh: false,
    dashboardData: {},
    purchasedCourseData: {},
    wishlistCourseData: {},
    errorMsg: "",
    isError: false
}

export const getDashboardData = createAsyncThunk('getDashboardData', async (body,{ rejectWithValue }) => {
    try {
        const { data, status } = await api.getDashboardData(body);
        if (status === 200) {
            return data
        }
    } catch (err) {
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const getPurchasedCourse = createAsyncThunk('getPurchasedCourse', async (body,{ rejectWithValue }) => {
    try {
        const params = {
            ...body,
            includeRefunded: true
        };
        
        const queryParams = new URLSearchParams(params).toString();
        const { data, status } = await api.getPurchasedCourse(queryParams);
        console.log('Purchased Course Data=============', data);
        
        return data
    } catch (err) {
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const getWishlistCourse = createAsyncThunk('getWishlistCourse', async (body,{ rejectWithValue }) => {
    try {
        const { data, status } = await api.getWishlistCourse(body);
        console.log('Wishlist data=============',data);
        
        return data
    } catch (err) {
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const deleteWishlistCourse = createAsyncThunk('deleteWishlistCourse', async (body,{ rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.deleteCourseToWishlist(body)

        if (status === 200) {
            Toastify.success('Course Removed From the Wishlist')
            dispatch(setRefresh())
        } 

        return data
    } catch (err) {
        Toastify.error(err.response.data.message || "'Something went wrong. Please try again later.'")
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const refreshPurchasedCourses = createAsyncThunk('refreshPurchasedCourses', async (_, { rejectWithValue, dispatch, getState }) => {
    try {
        const state = getState();
        const currentParams = {
            search: state.dashboard.purchasedCourseData.search || "",
            order: state.dashboard.purchasedCourseData.order || "",
            filterBy: state.dashboard.purchasedCourseData.filterBy || "",
            sortBy: "createdAt",
            includeRefunded: true
        };
        
        dispatch(getPurchasedCourse(currentParams));
        
        return { success: true };
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || "Failed to refresh courses");
    }
}
)

export const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        setRefresh: (state) => {
            state.isRefresh = !state.isRefresh
        },
        updateCourseRefundStatus: (state, action) => {
            const { courseId, isRefunded, orderStatus } = action.payload;
            
            if (state.purchasedCourseData?.courses) {
                const updatedCourses = state.purchasedCourseData.courses.map(course => 
                    course._id === courseId 
                        ? { 
                            ...course, 
                            isRefunded, 
                            orderStatus,
                            isCourseAccessible: !isRefunded && orderStatus !== "REFUNDED"
                          }
                        : course
                );
                
                state.purchasedCourseData.courses = updatedCourses;
                
                const accessibleCourses = updatedCourses.filter(course => 
                    !course.isRefunded && course.orderStatus !== "REFUNDED"
                );
                state.purchasedCourseData.accessibleCourses = accessibleCourses.length;
                state.purchasedCourseData.refundedCourses = updatedCourses.filter(course => 
                    course.isRefunded || course.orderStatus === "REFUNDED"
                ).length;
            }
        }
    },
    extraReducers: (builder) => {
        // getDashboardData
        builder.addCase(getDashboardData.pending, (state) => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getDashboardData.fulfilled, (state, action) => {
            state.isLoading = false
            state.dashboardData = action.payload
        })
        builder.addCase(getDashboardData.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })

        // getPurchasedCourse - FIXED
        builder.addCase(getPurchasedCourse.pending, (state) => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getPurchasedCourse.fulfilled, (state, action) => {
            state.isLoading = false
            state.purchasedCourseData = action.payload
        })
        builder.addCase(getPurchasedCourse.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })

        // getWishlistCourse
        builder.addCase(getWishlistCourse.pending, (state) => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getWishlistCourse.fulfilled, (state, action) => {
            state.isLoading = false
            state.wishlistCourseData = action.payload
        })
        builder.addCase(getWishlistCourse.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })

        // refreshPurchasedCourses
        builder.addCase(refreshPurchasedCourses.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(refreshPurchasedCourses.fulfilled, (state) => {
            state.isLoading = false
        })
        builder.addCase(refreshPurchasedCourses.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })
    }
})

export const {
    setRefresh,
    updateCourseRefundStatus
} = dashboardSlice.actions

export default dashboardSlice.reducer;